import React from "react";
import { Avatar, Typography } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { generateLink } from "../../../features/employees/EmployeesSlice";
const { Text } = Typography;

const EmployeeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const Employee = (props) => {
  const { record, tabindex } = props;
  const letter = record?.first_name?.charAt(0);
  const name = record ? record?.surename + " " + record?.first_name : "";
  const linkPath = useSelector((state) => {
    return generateLink(record?.id, state);
  });
  return (
    record && (
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        {record.avatar_url ? (
          <Avatar src={record.avatar_url} style={{ flexShrink: 0 }} />
        ) : (
          <Avatar
            style={{
              color: "#f56a00",
              backgroundColor: "#fde3cf",
              flexShrink: 0,
            }}
          >
            {letter}
          </Avatar>
        )}
        <Link
          style={{ color: "inherit", flexGrow: 1, minWidth: 0 }}
          to={{
            pathname: linkPath,
          }}
          tabIndex={tabindex}
        >
          <Text
            ellipsis={{ tooltip: name }}
            style={{
              padding: "0 10px",
              textDecoration: "underline",
              width: "100%",
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {name}
          </Text>
        </Link>
      </div>

      // <EmployeeWrapper>
      //   {record?.avatar_url ? (
      //     <Avatar src={record.avatar_url} />
      //   ) : (
      //     <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
      //       {letter}
      //     </Avatar>
      //   )}
      //   <Link
      //     style={{
      //       color: "inherit",
      //       textDecoration: "underline",
      //       padding: "0 10px",
      //     }}
      //     to={{
      //       pathname: linkPath,
      //     }}
      //     tabIndex={tabindex}
      //   >
      //     <div className="content">{name}</div>
      //   </Link>
      // </EmployeeWrapper>
    )
  );
};

export default Employee;
